import React from 'react';
import Icon from '../AppIcon';

const ProgressNavigation = ({ steps, currentStep, onStepClick }) => {
  const handleStepClick = (stepIndex) => {
    if (onStepClick && stepIndex <= currentStep) {
      onStepClick(stepIndex);
    }
  };

  return (
    <nav className="progress-nav">
      <div className="progress-nav-container">
        <div className="progress-nav-steps">
          {steps?.map((step, index) => {
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;
            const isClickable = index <= currentStep;

            return (
              <div
                key={step?.id}
                className={`progress-nav-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
              >
                <button
                  className="progress-nav-step-circle"
                  onClick={() => handleStepClick(index)}
                  disabled={!isClickable}
                  aria-label={`Step ${index + 1}: ${step?.label}`}
                  aria-current={isActive ? 'step' : undefined}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </button>
                <span className="progress-nav-step-label">{step?.label}</span>
                {index < steps?.length - 1 && (
                  <div className="progress-nav-step-connector" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default ProgressNavigation;